var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-img"},[_c('div',{staticClass:"circle"},[_c('img',{attrs:{"src":require("@/assets/circle.svg")}})]),_c('div',{staticClass:"tick"},[_c('img',{attrs:{"src":require("@/assets/tick.svg")}})])])
}]

export { render, staticRenderFns }